<template>
  <div class="page_">
    <div class="navbar_">
      <div class="main_">
        <img src="../../assets/medilink/videoCenter/header.png" alt="" />
        <div class="text_">
          <p>{{ $t("AMG[6]") || "视频中心" }}</p>
        </div>
      </div>
      <navbar :showHeader="showHeader" :nowIndex="3"></navbar>
    </div>
    <!-- <div class="block_">
    <p class="tit_">中间带宣传片</p>
    <div class="con_ w1000 swiper swiperP">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <video controls style="width: 100%; height: 500px; object-fit: fill" poster="../../assets/medilink/videoCenter/video1.png">
            <source :src="require('../../assets/medilink/demo.mp4')" type="video/mp4" />
          </video>
          <span class="play_"></span>
        </swiper-slide>
        <swiper-slide>
          <video controls style="width: 100%; height: 500px; object-fit: fill" poster="../../assets/medilink/videoCenter/video1.png">
            <source :src="require('../../assets/medilink/demo.mp4')" type="video/mp4" />
          </video>
          <span class="play_"></span>
        </swiper-slide> 
      </swiper>
      <div class="swiper-pagination pagination1" style="height:20px;"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div> -->
    <div class="block_" style="margin-bottom:50px;">
      <p class="tit_">{{ $t("videoCenter[1]") || "企业活动" }}</p>
      <div class="con_ w1000 swiper swiperP">
        <swiper ref="mySwiper" :options="swiperOptions1">
          <swiper-slide>
            <video
              style="width: 100%; height: 500px; object-fit: fill"
              id="myvideo"
              @mouseenter="showicon = true"
              @mouseleave="showicon = false"
              @ended="isPlay = false"
            >
              <source
                :src="require('../../assets/medilink/act.mp4')"
                type="video/mp4"
              />
            </video>
            <span class="play_" @click="playClick()" v-show="!isPlay"></span>
            <span
              class="play_ play_s"
              @click="stopClick()"
              v-show="isPlay === true && showicon === true"
            ></span>
          </swiper-slide>
          <swiper-slide>
            <video
              style="width: 100%; height: 500px; object-fit: fill"
              id="myvideo1"
              @mouseenter="showicon1 = true"
              @mouseleave="showicon1 = false"
              @ended="isPlay1 = false"
            >
              <source
                :src="require('../../assets/medilink/act2.mp4')"
                type="video/mp4"
              />
            </video>
            <span class="play_" @click="playClick1()" v-show="!isPlay1"></span>
            <span
              class="play_ play_s"
              @click="stopClick1()"
              v-show="isPlay1 === true && showicon1 === true"
            ></span>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination pagination2" style="height:20px;"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <footerbar></footerbar>
    <sideBar v-show="showBar"></sideBar>
  </div>
</template>
<script>
import footerbar from "./components/footer.vue";
import navbar from "./components/navbar.vue";
import sideBar from "./components/sideBar.vue";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      showHeader: false,
      height: 0,
      swiperOptions: {
        slidesPerView: 1,
        // loop:true,
        // autoplay: {
        //   delay: 1000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".pagination1",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          }
        }
      },
      swiperOptions1: {
        slidesPerView: 1,
        // loop:true,
        // autoplay: {
        //   delay: 1000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".pagination2",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          }
        }
      },
      showBar: false,
      isPlay: false,
      showicon: true,
      showBar1: false,
      isPlay1: false,
      showicon1: true
    };
  },
  mounted() {
    window.onscroll = () => {
      this.handleScroll();
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  components: {
    footerbar,
    navbar,
    Swiper,
    SwiperSlide,
    sideBar
  },
  directives: {
    swiper: directive
  },
  methods: {
    handleScroll(e) {
      var top = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageXOffset
      );
      this.height = top;
    },
    playClick() {
      this._dom = document.getElementById("myvideo");
      this.isPlay = true;
      this._dom.play();
    },
    stopClick() {
      this._dom = document.getElementById("myvideo");
      this.isPlay = false;
      this._dom.pause();
    },
    playClick1() {
      this._dom = document.getElementById("myvideo1");
      this.isPlay1 = true;
      this._dom.play();
    },
    stopClick1() {
      this._dom = document.getElementById("myvideo1");
      this.isPlay1 = false;
      this._dom.pause();
    }
  },
  watch: {
    height: {
      handler(newHeight, oldHeight) {
        if (newHeight > 400) {
          this.showBar = true;
          if (newHeight > oldHeight) {
            this.showHeader = false;
          } else {
            this.showHeader = true;
          }
        } else {
          this.showHeader = false;
          this.showBar = false;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  padding: 0;
  background-color: #fff;
  p {
    margin: 0;
  }
  .navbar_ {
    position: relative;
    width: 100%;
    .main_ {
      width: 100%;
      position: relative;
      color: #fff;
      & > img {
        height: auto;
        width: 100%;
        object-fit: cover;
      }
      .text_ {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        margin: 0 auto;
        font-weight: bold;
        font-size: 33px;
        text-align: center;
      }
    }
  }

  .block_ {
    width: 100%;
    color: #000000;
    font-size: 11px;
    position: relative;
    p {
      text-align: center;
    }
    .flex_ {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > .tit_ {
      font-weight: bold;
      color: #000;
      padding: 50px 0;
      font-size: 20px;
    }
    .drop {
      width: 4px;
      height: 4px;
      background-color: #00a63c;
      display: inline-block;
      margin: 0 16px;
    }
    .bold_ {
      font-weight: bold;
    }
    .con_ {
      color: #333;
      font-size: 11px;
      &.w1000 {
        width: 1000px;
        margin: 0 auto;
        &.swiper {
          position: relative;
          .swiper-container {
            height: 500px;
            .swiper-slide {
              height: 500px;
              position: relative;
              video {
                height: 500px;
              }
              .play_ {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                width: 55px;
                height: 55px;
                background: url(../../assets/medilink/videoCenter/play.png)
                  center center no-repeat;
                background-size: 55px 55px;
                z-index: 100;
                &.play_s {
                  background: url(../../assets/medilink/videoCenter/stopvideo.png)
                    center center no-repeat;
                  background-size: 55px 55px;
                }
              }
            }
          }
          .swiper-paginatio {
            right: 20px;
            bottom: 20px;
          }
        }
      }
    }
  }
}
</style>
